import * as MasterService from "@/apiServices/MastersServices";
import * as VendorServices from "@/apiServices/VendorServices";
import { debounce } from "@/utils/helpers";

export default {
  namespaced: true,
  state: {
    type: [],
    genre: [],
    age: [],
    language: [],
    director: [],
    cast: [],
    country: [],
    image_format: [],
    sound_format: [],
    aspect_ratio: [],
    label: [],
    media_type: [],
    distributor: [],
    pricing_code: [],
    contract_type: [],
    revenue_share: [],
    currency: [],
    milestone: [],
    bumper: [],
    contact_type: [],
    interest: [],
    release_movie_status:[],
    material_digital_category_type:[],
    // material_physical_category_type:[],
    banner_type:[],
    // Tree Data
    rights_tree: [],
    territory_tree: [],
    vendors: [],
    movies: [],
    territory: [],
    rights: [],
    sub_right: [],
    categorys: [],
    file_type: [],
    show_code: [],
    pricing_method: [],
    screen_definition: [],
    contribution_masters: [],
    // material_physical: [],
    material_digital: [],
    material_trailer: [],
    material_language_version: [],
    language_booking_code: [],
    depot_portal: [],
    synopsis_type: [],
    loading: {} 
  },

  getters: {
    allCasts: (state) => state.cast,
  },

  mutations: {
    SET_LABEL_MASTER(state, value) {
      const { key, val } = value;
      // Sort: active items first, deleted items at end
      const items = val || [];
      const active = items.filter((item) => !item.deleted);
      const deleted = items.filter((item) => item.deleted);
      state[key] = [...active, ...deleted];
    },
    SET_LABEL_TREE_MASTER(state, value) {
      const { key, val } = value;
      state[key] = val;
    },
    SET_TERRITORY_TREE(state, value) {
      state.territory_tree = value
    },
    SET_RIGHT_TREE(state, value) {
      state.rights_tree = value
    },
    SET_VENDORS_MASTER(state, value) {
      state.vendors = value;
    },
    SET_MOVIES_MASTER(state, value) {
      state.movies = value;
    },
    SET_CONTRACT_TYPE_MASTER(state, value) {
      state.contract_types = value;
    },
    SET_LOADING(state, { key, value }) {
      state.loading = {
        ...state.loading,
        [key]: value
      };
    },
  },
  actions: {
    setLabelMaster: async ({ commit }, payload) => {
      const key = payload.key;

      commit("SET_LOADING", { key, value: true });
      commit("SET_LABEL_MASTER", { key, val: [] });

      try {
        const response = await MasterService.getAllData({ master: key });

        if (response.data.status) {
          commit("SET_LABEL_MASTER", {
            key,
            val: response.data.data.rows,
          });
        } else {
          console.log(response.data);
        }
      } catch (err) {
        console.log("Error in getting master data ", err);
      } finally {
        commit("SET_LOADING", { key, value: false });
      }
    },

    setLabelTreeMaster: async ({ commit }, payload) => {
      const key = payload.key;

      commit("SET_LOADING", { key, value: true });
      commit("SET_LABEL_TREE_MASTER", { key, val: [] });

      try {
        const response = await MasterService.getAllTreeDataActive(
          payload.master,
          payload.sub_master
        );

        if (response.data.status) {
          commit("SET_LABEL_TREE_MASTER", {
            key,
            val: response.data.data,
          });
        } else {
          console.log(response.data);
        }
      } catch (err) {
        console.log("Error in getting tree master data ", err);
      } finally {
        commit("SET_LOADING", { key, value: false });
      }
    },

    setVendorsMaster: debounce(async ({ commit }, payload) => {
      const key = "vendors";

      commit("SET_LOADING", { key, value: true });
      commit("SET_VENDORS_MASTER", []);

      try {
        const response = await VendorServices.getAllVendor({
          deleted: false,
          ...payload,
        });

        if (response.data.status) {
          commit("SET_VENDORS_MASTER", response.data.data.data);
        } else {
          console.log(response.data);
        }
      } catch (err) {
        console.log("Error in getting vendors master data ", err);
      } finally {
        commit("SET_LOADING", { key, value: false });
      }
    }),

    setMoviesMaster: debounce(async ({ commit }, payload) => {
      const key = "movies";

      commit("SET_LOADING", { key, value: true });
      commit("SET_MOVIES_MASTER", []);

      try {
        const response = await MasterService.getAllMovies({
          archived: false,
          draft: false,
          ...payload,
        });

        if (response.data.status) {
          commit("SET_MOVIES_MASTER", response.data.data);
        } else {
          console.log(response.data);
        }
      } catch (err) {
        console.log("Error in getting movies master data ", err);
      } finally {
        commit("SET_LOADING", { key, value: false });
      }
    }),

    setTerritoryMaster: async ({ commit }, payload) => {
      const key = "territory_tree";

      commit("SET_LOADING", { key, value: true });
      commit("SET_TERRITORY_TREE", []);

      try {
        const response = await MasterService.getMasterList({
          list_route: `territory-tree`,
          params: payload,
        });

        if (response.data.status) {
          commit("SET_TERRITORY_TREE", response.data.data);
        } else {
          console.log(response.data);
        }
      } catch (err) {
        console.log("Error in getting territory master data ", err);
      } finally {
        commit("SET_LOADING", { key, value: false });
      }
    },

    setRightMaster: async ({ commit }, payload) => {
      const key = "rights_tree";

      commit("SET_LOADING", { key, value: true });
      commit("SET_RIGHT_TREE", []);

      try {
        const response = await MasterService.getMasterList({
          list_route: `right-tree`,
          params: payload,
        });

        if (response.data.status) {
          commit("SET_RIGHT_TREE", response.data.data);
        } else {
          console.log(response.data);
        }
      } catch (err) {
        console.log("Error in getting right master data ", err);
      } finally {
        commit("SET_LOADING", { key, value: false });
      }
    },
  },
};
